import {
  getTruncatedLabelForItemsColumn,
  QuoteStatus,
  QuotesSubTabs
} from '@common/utils'
import {
  type ColumnCellTemplateData,
  MolsonBox,
  MolsonShowMoreButton
} from '@components/reusable'
import type { TFunction } from 'i18next'
import { TypographyWithClamping } from '../typography-with-clamping/TypographyWithClamping'

type RenderItemItemsProps = {
  params: ColumnCellTemplateData
  handleOnClick: ((quoteId: number) => void) | (() => void)
  keyPrefix: string
  t: TFunction
  gridTab?: QuotesSubTabs
}

export const renderItemItemsColumn = ({
  params,
  handleOnClick,
  keyPrefix,
  gridTab,
  t
}: RenderItemItemsProps) => {
  const quotationId = params.data.id
  const maxNoOfItemsDisplayed = 1

  const items = params?.data?.itemsSearchData?.split(';').filter(Boolean)
  const isArchivedQuote = params.data.status === QuoteStatus.ARCHIVED
  const disabledState = isArchivedQuote && gridTab !== QuotesSubTabs.ARCHIVED

  return (
    <MolsonBox
      display="flex"
      gap={2}
      justifyContent="space-between"
      alignItems="center"
    >
      <TypographyWithClamping
        variant="body2"
        labelToClamp={
          items.length === 0
            ? t(`${keyPrefix}.noItems`)
            : getTruncatedLabelForItemsColumn(items, maxNoOfItemsDisplayed)
        }
        sx={{
          opacity: disabledState ? 0.5 : 1
        }}
      />

      {items.length > maxNoOfItemsDisplayed ? (
        <MolsonShowMoreButton onClick={() => handleOnClick(quotationId)}>
          {t(`${keyPrefix}.more`)}
        </MolsonShowMoreButton>
      ) : null}
    </MolsonBox>
  )
}
